import React, { useState, useEffect, useContext }from "react";
import { useNavigation } from '@react-navigation/native'; // esto te sirve para navegar en el ambiente donde invocaste este componente
import { Image, FlatList, View, StyleSheet, TouchableWithoutFeedback, TouchableOpacity,Dimensions, ScrollView } from "react-native";
import { Image as ImageCache } from "react-native-expo-image-cache";
//import { PieChart } from "react-native-gifted-charts";
import { PieChart } from "react-native-chart-kit";

import { Audio } from 'expo-av';

//import useAuth from "../auth/useAuth";
import dateNow from "../utility/dateNow";
import configurationPost from "../config/configurationPost";
import connectionConfig from "../config/settings";      
import Text from "./Text";
import colors from "../config/colors";
import routes from "../navigation/routes";
import { MaterialCommunityIcons, Foundation } from "@expo/vector-icons";
import AuthContext from "../auth/context";


const webUrl = connectionConfig.imageUrl + '/seedImages/'
var date = dateNow()
var numLikes = 0

function CardRequirements({ 
    type,
    title,
    seedDescription, 
    seedId,
    seedName,
    seedPhoto,
    origin,
    imageUrl,
    onPress,
    thumbnailUrl,
    screen,
    qty,
    mesure,  
    unitaryPrice,
    currency,
    sub,
    note,
    userName,
    userId,
    userPhoto,
    ifBringRequirementItems,
    totalSeedLikes,
    totalSeedComments,
    onPressComment,
    foundUserChecker 
                }) {

const navigation = useNavigation(); // esto te sirve para navegar en el ambiente donde invocaste este componente
const { user } = useContext(AuthContext)
const [requirementStatus, setRequirementStatus] = useState("");
const [verMas, setVerMas] = useState("menos");
const [verMasApoyos, setVerMasApoyos] = useState("menos");
const [seePriceSub, setSeePriceSub] = useState("no");

const [ titleBoxText, setTitleBoxText ] =  useState('') // para que jale el comentario
const [ descriptionBoxText, setDescriptionBoxText ] =  useState('') // para que jale el comentario 
const [imageUri, setImageUri] = useState('');
const [itemsSupport, setItemsSupport] = useState([]);

var profileUri =  connectionConfig.imageUrl +'/PerfilDeUsuario/'
var userIdAuth = JSON.parse(user).userId;


useEffect(() => {
  //debugger
  bringSupportItems()
  }, [numLikes]);


  
  const bringSupportItems = async () => {
    var post_values = {
     origin: seedId,  // Lleva el seedId en origin para que busque los renglones de requerimientos.
     type: 41  //type40
  }
  configurationPost.body = JSON.stringify(post_values) 
  
  //await fetch(connectionConfig.apiUrl+'/selectRequirementActions/', configurationPost)
  await fetch(connectionConfig.apiUrl+'/SelectSupportActions/', configurationPost)

       .then(response => response.json())
       .then(response => {
        setItemsSupport(response)
       } )
       .catch(err =>{
            console.log('bringRequirementItems /selectRequirementActions/ failed :( review internet service)', err )
       })

    }

// ********** Código para sumar los items de cada apoyo de un requerimiento **************
    var qtySupports = (itemsSupport.length) // Este en particular es para sacar los apoyos de un requerimiento en particular.
    var sumSupports = ''
    sumSupports = itemsSupport.map((element) => (element.qty) ); 
    var totalSupports = 0
  //totalSupports = sumSupports.reduce(function(a, b){ return a + b, 0 }) // Esta forma antigua de escribir js no le gusta a recat native
    totalSupports = sumSupports.reduce((a, b) => a + b, 0 ); // Con esta forma nueva si la reconoce react native :)
  
    var requirementsToFulfill = 0    // Requerimeintos por completar
    requirementsToFulfill = (qty - totalSupports)     

    var percentageSuccess = 0       // Porcentaje de requerimientos completados 
    percentageSuccess = (totalSupports/qty)*100

    if(percentageSuccess === 0){    // Ifeo para meterle sólo dos decimales al resultado (si es distinto de cero)
      percentageSuccess
    } else{
    percentageSuccess = percentageSuccess.toFixed(2)  // Método en si para ponerle decimales (dos) 
    }
    
// ********** Función para ir a editar requerimiento ******************
const editRequirement = async () => {
  seedId = seedId
  //seedDate = seedDate
  type = type
  screen = 'ChooseTypeContent'
  navigation.navigate(   // Este edit tambien sirve para editar case 41 (SUPPORT). Por eso mando el userName, userdId y userPhoto.
    routes.ACTION_EDIT_SCREEN,
     { seedId, screen, type, userName, userId, userPhoto }
  ) 
  //navigation.navigate(routes.ACTION_EDIT_SCREEN, { type, seedId, origin, foundUserChecker, changeListing, seedDate, seedOrder, seedPhoto, screen, itemsRequirements } ) 
}

// ********** Código para Ifear la flecha para mostrar Precio U. y Subtotal **************
var ifShowPriceSub = ""
if(unitaryPrice !== 0 && seePriceSub === "no"){
  ifShowPriceSub = "show"
}else if(unitaryPrice !== 0 && seePriceSub === "yes"){
  ifShowPriceSub = "dontShow"
}else{
  null
}

//********** Datos para la gráfica de requerimientos **********
const pieData = [
  { value: totalSupports, 
    color: '#35AB20', 
    name: 'Progreso', 
    legendFontSize: 15,
    legendFontColor: '#7F7F7F'
  },
  {
    value: requirementsToFulfill,
     color: 'lightgray', 
     name: 'Pendiente',  
     legendFontSize: 15, 
     legendFontColor: '#7F7F7F'
  }
];

//Función que se encarga de hacer la gráfica de pie
const MyPieChart = () => {
  return (
    <>
      <PieChart        
         data={pieData}
          chartConfig={{
          backgroundColor: '#1cc910',
          backgroundGradientFrom: '#eff3ff',
          backgroundGradientTo: '#efefef',
          decimalPlaces: 2,
          color: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
          style: {
            //borderRadius: 16,
            width:200,
             height:200
           // margin:2
          },
        }}
        //estilos que impactan la gráfica por fuera
        style={{
          marginVertical: 8,
         marginLeft:100,
 
          borderRadius: 16,
        }}
        accessor="value"
        backgroundColor="transparent"
        padding="15"
        paddingLeft='40'
        width={500}
        height={200}
        //absolute //for the absolute number remove if you want percentage
      />
    </>
  );
};
//**************************************************************


// ***************************************     Inicia block de los likes    ***************************************************
//---------------------------------------------------------------------------------------------------------------------------
//  1. Servicio que valida si ya existe el like del usuario en la publicación (función inicio del encadenamiento de servicios) 
//---------------------------------------------------------------------------------------------------------------------------
const onPressValidationLikeUser = async () => {

  console.log("Este es el SeedId en rutina likes CardComponent ", seedId, userId )
  try {
    const { sound } = await Audio.Sound.createAsync(
      require('../assets/sounds/ringtones-heart.mp3')   // Ejecuta un sonido al hacer like  
    )
    await sound.playAsync()
  } catch (err) {
    console.log(':(', err )
  }
  //debugger
  var post_values = {
   seedId :  seedId, //filtroListing.seedId,
   userId :  userId  //JSON.parse(user).userId
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/SelectValidateSeedsLikes/', configurationPost)
  .then(response => response.json())
  .then(response => {
    console.log("response.data.length ", response.data.length)
    if (response.data.length != 0) {   
       deleteLikePublication()
    } else {
      insertLike()           
     }
  })
  .catch(err =>{
  console.log(':( review internet service', err )
  })
}

//--------------------------------------------------------
// 2. servicio que borra el like si ya existe en la publicación
//---------------------------------------------------------
const deleteLikePublication = async () => {
  var post_values = {
    seedId : seedId,
    userId : userId  //JSON.parse(user).userId
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/deleteLikeSeeds/', configurationPost)
  .then(response => response.json())
  .then(response => {
    countOfLikes()
   })
   .catch(err =>{
   console.log(':( review internet service /deleteLikeSeeds/', err )
   })
}   

//-------------------------
// 2.1. Agrega un nuevo like 
//-------------------------
const insertLike = async  () => {
   // debugger
  var post_values = {
      seedId : seedId,    //filtroListing.seedId, 
      userId : userId,    //JSON.parse(user).userId,
      dateLikeSeed : date,
      likeType : 1
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/insertSeedLike/', configurationPost) 
  .then(response => response.json())
  .then(response => {
    countOfLikes()    
  })
  .catch(err =>{
  console.log('Insert fixo failed :( review internet service -> insertSeedLike', err )
  })
}

//------------------------------------------------------------------
// 3. Servicio que nos va a traer el count de likes por semilla.
//------------------------------------------------------------------
const countOfLikes = async () => {
   var post_values = {
      seedId : seedId    //filtroListing.seedId, 
    }
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/SelectCountSeedLikes/', configurationPost)
   .then(response => response.json())
   .then(response => {
     numLikes = response.data[0].total_likes
     incrementLikes()
     
   })
   .catch(err =>{ 
   console.log(':( review internet service => /SelectCountSeedLikes/', err )
   })
}
//------------------------------------------------------------------------------
// 4. servicio que hace un incremeto al campo de número de likes de una semilla
//------------------------------------------------------------------------------
const incrementLikes = async () => {
        //debugger

        var post_values = {
          seedId : seedId, //filtroListing.seedId, 
          totalSeedLikes : numLikes
      }
      configurationPost.body = JSON.stringify(post_values)
      await fetch(connectionConfig.apiUrl+'/UpdateIncrementLikeSeeds/', configurationPost) 
      .then(response => response.json())
      .then(response => {
        ifBringRequirementItems2()
      
      })
      .catch(err =>{
      console.log('Insert fixo failed :( review internet service /UpdateIncrementLikeSeeds/', err )
      })
}
//------------------------------------------------------------------------------------------
// Función que invoca la función getContentActions via props desde ListingDetailsSeedScreen 
//------------------------------------------------------------------------------------------
const ifBringRequirementItems2 = async () => {
  ifBringRequirementItems()
}
// ********************************************* Termina block de los likes  *********************************************//


// ********** Código para Ifear el foundUserChecker y determinar si se es el autor  **************
if(userId === userIdAuth){
  foundUserChecker = "off" 
}else{
  null
}

//----------------------------------------------------------------
// Función para generar el seedId para el componente Support 41 
//----------------------------------------------------------------
const addSupport41 = async () => {
 
  console.log("seedId en addSupport41 en CardCRequirement, seedName ", seedId, " ", seedName)
 
  var post_values = {
      userId           : userId,
      createDateSeed   : date,
      type             : 41,
      origin           : origin,
      seedName         : seedName,
      seedDescription  : 'Descripción... ',
      seedPhoto        : 'Poner Foto ',
      documentSeed     : 'Poner documento',
      youtubeId        : 'link',
      seedOrder        : 999
 
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/insertAction/', configurationPost)
    .then(response => response.json())
    .then(response => {
      console.log( {response} + "Response despues de post GenerateActionId ChooseTypeContent")
      newSeedId = response.data.insertId
      //seedId = newSeedId
      console.log("Este es el nuevo seedId desde ChooseTypeContent: " + newSeedId)
    })
    .catch(err =>{
      console.log('update fixo failed :( review internet service /insertAction/', err )
    })
    selectInfoAction()
 };
 
     const selectInfoAction = async () => {
       origin = seedId  //origin 
       seedId = newSeedId
       foundUserChecker = foundUserChecker
       seedDate = date
       type = 41
       seedOrder = 999
       var screen = 'ChooseTypeContent'
       var changeListing = 'true'
        navigation.navigate(routes.ACTION_EDIT_SCREEN, { type, seedId, origin, foundUserChecker, changeListing, seedDate, seedOrder, screen } ) 
     }
 
 
switch (screen) {

  case 0: // Cuando viene de CardComponent.js y es el creador de la semilla (tiene acceso a edición) 
  return (
    <View style={styles.card}>
                <View style={styles.likeAndCommentContainer5}> 
                           <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={"red"} 
                                              size={30} 
                                              onPress={ () => {
                                                onPressValidationLikeUser()
                                               }
                                              }
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                                  numberOfLines={2} 
                                  // onPress={onPressNumLikes}
                                  >
                                  {totalSeedLikes}
                            </Text>
                            <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={30} 
                                              onPress={onPressComment} 
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                                  numberOfLines={1} >
                                  {totalSeedComments}
                            </Text>
                </View>

      <View style={{height: 200, width: '100%', alignItems: "center", marginBottom: "4%"}}>
            {/* <PieChart  //https://gifted-charts.web.app/piechart
                donut
                radius={85}
                innerRadius={60}
                data={pieData}
                centerLabelComponent={() => {
                      return <Text style={{fontSize: 25}}>{percentageSuccess.toLocaleString()}%</Text>;
                }}
            /> */} <MyPieChart />
      </View>
     

      <View style={styles.buttonsTop}>
      <Text style={styles.title} > {seedId}   </Text> 

                 {
                  requirementsToFulfill > 0 ?  
                    <TouchableOpacity  style={styles.buttonEdit}
                                        onPress={ () => { 
                                          //setRequirementStatus("completo")
                                          addSupport41()
                                        }} 
                                      >
                        <Text style={styles.textEdit}>
                          Apoyar!
                        </Text>
                    </TouchableOpacity>
                  :
                    <TouchableOpacity style={styles.buttonEdit} 
                                      onPress={ () => 
                                      setRequirementStatus("incompleto")
                                     }
                                   >
                       <Text style={styles.textEdit}>
                          Requerimiento completo.
                       </Text>
                    </TouchableOpacity> 
                   }

                    <TouchableOpacity  style={styles.buttonEdit}
                                        onPress={ () => { 
                                          editRequirement()
                                        }} 
                                      >
                        <Text style={styles.textEdit}>
                          Editar 
                        </Text>
                    </TouchableOpacity>
        </View>  
  

    <View style={styles.viewContent6PhotoYText}  >
        <View style={styles.viewContent6Image} > 
            {  
              imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
              <View style={styles.image} >
                          <Foundation 
                            name="mountains" 
                            size={120} 
                            color={colors.medium} />
              </View>
              :  
              imageUrl === 'http://18.116.234.21:5001/seedImages/Poner Foto ' ?
              <View style={styles.image} >
                          <Foundation 
                            name="mountains" 
                            size={120} 
                            color={colors.medium} />
              </View>
              :
              <ImageCache
                onPress={onPress}
                style={styles.image}
                tint="light"
                preview={{ uri: thumbnailUrl }}
                uri={imageUrl}
                resizeMode= "stretch" // Con esto logré que la imagen se adecuara a un view más pequeño!!   //"center"
              />
            }
            
              
            {
              totalSupports > 0 ?
              <View style={{marginTop: "3%"}}>
                <Text style={{fontSize: 20,  
                                   color: "black",
                                   marginLeft: "8%",
                                   marginTop: "-1%"}}> Apoyos: </Text> 
              
                <View style={{alignItems: "center", 
                              width: "50%"}}>
                <Text style={{fontSize: 18,  
                                   color: "black",
                                   marginTop: "-1%"}}> {qtySupports.toLocaleString()} </Text>
                </View>
                {
                  verMasApoyos === "menos" ?  
                    <TouchableOpacity  style={styles.buttonVerApoyos}
                                        onPress={ () => { 
                                          setVerMasApoyos("mas")
                                          console.log("clic ver apoyos ")
                                        }} 
                                      >
                        <Text style={styles.textEdit}>
                          Ver apoyos
                        </Text>
                    </TouchableOpacity>
                  :
                    <TouchableOpacity style={styles.buttonVerApoyos} 
                                      onPress={ () => 
                                        setVerMasApoyos("menos")
                                     }
                                   >
                       <Text style={styles.textEdit}>
                          Ver menos...
                       </Text>
                    </TouchableOpacity> 
                   }
                  
                </View>
              :
                null
            }
            
        </View>
           <View style={styles.viewContent6TitleYSeedDescription}> 
           <Text style={styles.textQtyMesure}>  Concepto  </Text>
           <Text style={styles.textConceptNote} >{seedName}  </Text>
           <View style={styles.viewQtyMesure}>
                  <Text style={styles.textQtyMesure} > Cantidad </Text>
                  <Text style={styles.textQtyMesure} >          Unidad  </Text>
           </View>
           <View style={styles.viewQtyMesure}>
                  <Text style={styles.textBoxQty}> {qty}    </Text>
                  <Text style={styles.textBoxMesure}> {mesure} </Text>
                  {
                    ifShowPriceSub === "show" ?
                      <MaterialCommunityIcons
                      onPress = {()=> setSeePriceSub("yes")}
                      name={"chevron-down"}
                      size={25}
                      color={colors.medium}
                      />
                    :
                    null
                  }
                  {
                    ifShowPriceSub === "dontShow" ?
                      <MaterialCommunityIcons
                      onPress = {()=> setSeePriceSub("no")}
                      name={"chevron-up"}
                      size={25}
                      color={colors.medium}
                      />
                    :
                    null
                  }
           </View>

                { 
                  seePriceSub === "no" ?
                    null
                  :
                    <View >
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textQtyMesure}> Precio U. </Text>
                              <Text style={styles.textQtyMesure}>    Subtotal </Text>
                          </View>
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textBoxPrice}> {unitaryPrice} </Text>
                              <Text style={styles.textBoxSub}> {sub.toLocaleString()}          </Text>
                          </View>
                    </View>
                }

                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textQtyMesure}> Aportado </Text>
                              <Text style={styles.textQtyMesure}>          Faltan: </Text>
                          </View>
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textBoxQty}> {totalSupports.toLocaleString()} </Text>
                              <Text style={styles.textBoxQty}> {requirementsToFulfill.toLocaleString()}          </Text>
                          </View>
            <Text style={styles.textConceptNote} >Nota: {seedDescription} </Text>
          </View>
   </View>
                  {
                    verMasApoyos === "mas" ?
                         <FlatList
                                data={itemsSupport}
                                keyExtractor={(item) => item.seedId.toString()}
                                //ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardRequirements
                                    type = { item.type }
                                    title = {item.title}
                                    seedDescription = { item.seedDescription }
                                    seedId = { item.seedId }
                                    seedName = { item.seedName }
                                    seedPhoto = { item.seedPhoto }
                                    origin = { item.origin }
                                    thumbnailUrl={ item.thumbnailUrl }
                                    imageUrl={
                                      seedPhoto.includes('.mp4') ?
                                      seedVideoUri + seedPhoto :
                                      seedPhoto.includes('.mov') ?
                                      seedVideoUri + seedPhoto :
                                      webUrl + seedPhoto}
                                    screen = {3}
                                    qty = { item.qty }
                                    mesure = { item.mesure }
                                    unitaryPrice = { item.unitaryPrice }
                                    currency = { item.currency }
                                    sub = { item.sub }
                                    note = { item.note }
                                    userName = { item.userName }
                                    userId = { item.userId }
                                    userPhoto = { item.userPhoto }
                                    ifBringRequirementItems={() => {ifBringRequirementItems()}}
                                    totalSeedLikes = { item.totalSeedLikes }
                                    totalSeedComments = { item.totalSeedComments }
                                    onPressComment = { onPressComment }
                                    onPress={() =>{ 
                                      date = dateNow()
                                      newSeedDate = dateActions(date)
                                      typeActionSelect = menuArrangePhotosComponent35[index].typeActionsId
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      selectingArrangeImage(typeActionSelect)
                                    }}
                                  />
                                )}
                              />
                      :
                        null
                  }
</View>
);

  case 1: // Este por increíble que parezca venía de CardEdit pero esto medtando si lo dejo así.
    return (
      <View style={styles.card}>

                      <TouchableOpacity  style={styles.buttonEdit}
                                        onPress={ () => { 
                                          editRequirement("completo")
                                          //navigation.navigate(routes.ACTION_EDIT_SCREEN, { type, seedId, seedDate, origin, foundUserChecker, screen } )  // ADD_COMPONENT
                                        }} 
                                      >
                        <Text style={styles.textEdit}>
                          Editar
                        </Text>
                      </TouchableOpacity>
 
            <Text style={styles.title} > {seedId}   </Text> 
    <View style={styles.viewContent6PhotoYText}  >
        <View style={styles.viewContent6Image} > 
        {  
         imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
            <View style={styles.imageMountain} >
               <Foundation //style={styles.imageMountain}
                           name="mountains" 
                           size={350} 
                           color={colors.medium} />
            </View>
          :  
          imageUrl === 'http://18.116.234.21:5001/seedImages/Poner Foto ' ?
          <View style={styles.image} >
                      <Foundation 
                        name="mountains" 
                        size={120} 
                        color={colors.medium} />
          </View>
          :               
            <ImageCache
              onPress={onPress}
              style={styles.image}
              tint="light"
              preview={{ uri: thumbnailUrl }}
              uri={imageUrl}
            />
        }

        </View>
    <View style={styles.viewContent6TitleYSeedDescription}>
        <Text style={styles.Title6} >Cantidad: 3 </Text>
        <Text style={styles.Title6} >{seedName} </Text>
        <Text style={styles.Title6} >{seedDescription}</Text>
    </View>
  </View>
    
</View>
);
  
  case 2:  // Cuando viene de CardComponent.js pero no eres el creador de la semilla
  return (
    <View style={styles.card}>
 {
                     requirementsToFulfill > 0 ?  
                    <TouchableOpacity  style={styles.buttonEdit}
                                        onPress={ () => { 
                                          setRequirementStatus("completo")
                                          console.log("clic en Apoyar ")
                                          //navigation.navigate(routes.ACTION_EDIT_SCREEN, { type, seedId, seedDate, origin, foundUserChecker, screen } )  // ADD_COMPONENT
                                        }} 
                                      >
                        <Text style={styles.textEdit}>
                          Apoyar!
                        </Text>
                      </TouchableOpacity>
                    :
                        <TouchableOpacity  
                          style={styles.buttonEdit}
                          onPress={ () => 
                            setRequirementStatus("incompleto")
                          }
                        >
                       <Text style={styles.textEdit}>
                           Requerimiento completo. Ver+
                       </Text>
                       </TouchableOpacity> 
                   }

<Text style={styles.title} > {seedId}   </Text> 
{/* <TouchableOpacity onPress={onPress}> */}
<View style={styles.viewContent6PhotoYText}  >
 <View style={styles.viewContent6Image} > 
 {  
   imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
   <View style={styles.imageMountain} >
               <Foundation //style={styles.imageMountain}
                           name="mountains" 
                           size={350} 
                           color={colors.medium} />
   </View>
  :  
  imageUrl === 'http://18.116.234.21:5001/seedImages/Poner Foto ' ?
  <View style={styles.image} >
              <Foundation 
                name="mountains" 
                size={120} 
                color={colors.medium} />
  </View>
   :               
   <ImageCache
     onPress={onPress}
     style={styles.image}
     tint="light"
     preview={{ uri: thumbnailUrl }}
     uri={imageUrl}
   />
 }

 </View>
 <View style={styles.viewContent6TitleYSeedDescription}>
     <Text style={styles.Title6} >
      Cantidad: 3
     </Text>
     <Text style={styles.Title6} >
       {seedName}
     </Text>
     <Text style={styles.Title6} >
       {seedDescription}
     </Text>
 </View>
</View>
{/* </TouchableOpacity> */}
<View style={styles.detailsContainer}>
</View>
</View>

  );

  case 3:  // A P O Y O S => Cuando viene de este mismo componente para renderizar apoyos
  return (
    <View style={styles.cardApoyo}>
 
        <Text style={{fontSize: 20, textAlign: "right", marginRight: "3%", marginBottom: "2%"}} >  {seedId}   {userName}   </Text> 

    <View style={styles.viewApoyo}  >
    { 
            unitaryPrice === 0 ?
            <View style={styles.viewContent6TitleYSeedDescriptionApoyo}>
                  <View style={styles.viewBoxesApoyo}>
                      <Text style={styles.textQtyMesure} > Cantidad </Text>
                      <Text style={styles.textQtyMesureApoyo} >              Unidad  </Text>
                  </View>
                  <View style={styles.viewBoxesApoyo}>
                      <Text style={styles.textBoxQtyMesure}> {qty}    </Text>
                      <Text style={styles.textBoxQtyMesure}> {mesure} </Text>
                  </View>
                  <Text style={styles.textNoteSupport} >Nota: {seedDescription} </Text>
            </View>
            :
            <View style={styles.viewContent6TitleYSeedDescriptionApoyo}>
                  <View style={styles.viewBoxesApoyo}>
                      <Text style={styles.textQtyMesure}> Apoyo </Text>
                      <Text style={styles.textQtyMesure}>                 Unidad   </Text>
                  </View>
                  <View style={styles.viewBoxesApoyo}>
                      <Text style={styles.textBoxQtyMesure}> {qty}    </Text>
                      <Text style={styles.textBoxQtyMesure}> {mesure} </Text>
                  </View>
                  <View style={styles.viewBoxesApoyo}>
                      <Text style={styles.textQtyMesure}> Precio U. </Text>
                      <Text style={styles.textQtyMesure}>              Subtotal  </Text>
                  </View>
                  <View style={styles.viewBoxesApoyo}>
                      <Text style={styles.textBoxQtyMesure}> {unitaryPrice} </Text>
                      <Text style={styles.textBoxQtyMesure}> {sub.toLocaleString()}          </Text>
                  </View>
                  {/* <Text style={styles.Title6} > {seedName}  </Text> */}
                  <Text style={styles.textNoteSupport} >Nota: {seedDescription} </Text>
            </View>
          }

        <View style={styles.viewImageUser} > 
            {  
              imageUrl === 'http://18.116.234.21:5001/imagenes/PerfilDeUsuario' ?
              <View style={styles.imageUser} >
                          <Foundation 
                                      name="mountains" 
                                      size={100} 
                                      color={colors.medium} />
              </View>
              :   
              <TouchableOpacity
              onPress={() => {
                  var item = {userId, userPhoto, userName}
                  var foundUserChecker = "foundUserChecker"
                  {if(userId === userIdAuth){
                    navigation.navigate(routes.USER_FIXO)
                  }else{
                  navigation.navigate(routes.FOUND_USER, { item, foundUserChecker })
                  }}
                }}
              >
              <ImageCache
                style={styles.imageUser}
                tint="light"
                preview={{ uri: thumbnailUrl }}
                //uri={imageUrl}
                uri={profileUri + userId + '_' + userPhoto}
                
              />
              </TouchableOpacity>             
            }
              {
                userId === userIdAuth ?
                   <TouchableOpacity  style={styles.buttonEdit}
                                        onPress={ () => { 
                                          editRequirement()
                                        }} 
                                      >
                        <Text style={styles.textEdit}>
                          Editar 
                        </Text>
                    </TouchableOpacity>
                  :
                  null
              }
        </View>
   </View>
   <View style={styles.likeAndCommentContainer5}> 
                           <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={"red"} 
                                              size={30} 
                                              onPress={ () => {
                                                onPressValidationLikeUser()
                                               }
                                              }
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                                  numberOfLines={2} 
                                  // onPress={onPressNumLikes}
                                  >
                                  {totalSeedLikes}
                            </Text>
                            <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={30} 
                                              onPress={onPressComment} 
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                                  numberOfLines={1} >
                                  {totalSeedComments}
                            </Text>
                </View>
                {
                  verMas === "mas" ?  
                      <MaterialCommunityIcons
                      onPress = {()=> setVerMas("menos")}
                      name={"chevron-up"}
                      size={35}
                      color={colors.medium}
                      style={{alignSelf: "center"}}
                      />
                  :
                      <MaterialCommunityIcons
                      onPress = {()=> setVerMas("mas")}
                      name={"chevron-down"}
                      size={35}
                      color={colors.medium}
                      style={{alignSelf: "center"}}
                      />
                }
                
                {
                  verMas === "mas" ?  
                         
                             seedPhoto === 'Poner Foto ' ?   
                             <View style={styles.imageSupport} >
                                  <Foundation 
                                      name="mountains" 
                                      size={400} 
                                      color={colors.medium} />
                             </View>
                             :
                             String(seedPhoto).includes('.png') ?
                             <ImageCache
                                 style={styles.imageSupport}
                                 //preview={{ uri: webUrl + seedPhoto }}
                                 preview={{ uri: thumbnailUrl }}
                                 tint="light"
                                 uri= { webUrl + seedPhoto }
                                 //uri={imageUrl}
                             /> 
                             :
                             <ImageCache
                                 style={styles.imageSupport}
                                 //preview={{ uri: webUrl + seedPhoto }}
                                 preview={{ uri: thumbnailUrl }}
                                 tint="light"
                                 uri= { webUrl + seedPhoto }
                                 //uri={imageUrl}
                                 //resizeMode= "cover"
                             />   
                             :  
                             // Este Image que viene no lo pude quitar porque sino me da un error :(
                            <ImageCache         
                            />      
                         }

</View>
);

  default: 
  <Text> type: {type} </Text>
  break; 
}

 }

const styles = StyleSheet.create({

  imageSupport: {  //Imagen agregada en Support
    marginTop: "2%",
    marginLeft: "1%",
    marginBottom: "3%",
    height: 400,
    width:  400,        //"100%",
    backgroundColor: colors.chakra8tur,
  },
  likeAndCommentContainer5: {
    flexDirection: "row",
    width: "90%",
    height: 30,
    //marginLeft: "10%",
    marginTop: "1%",
    alignItems: "center",
    //backgroundColor: "green",
 },
 
 likeAndCommentContainer5Nums: {
  marginLeft: "10%",
  color: colors.medium,
},

likeAndCommentContainer5Icons: {
  marginLeft: "20%",
  //backgroundColor: "green",
},

  viewQtyMesure: {
    flexDirection: "row",
    width: "40%",
    marginLeft: "2%",
    //backgroundColor: "gray",
  },
  viewBoxesApoyo: {
    flexDirection: "row",
    width: "85%",
    marginLeft: "2%",
    //backgroundColor: "gray",
  },
  textQtyMesure: {
    fontSize: 18,  
    color: "black",
  },
  textConceptNote: {
    fontSize: 18,  
    color: "black",
    marginTop: "1%",
    marginLeft: "2%",
    paddingLeft: "1%",
    marginBottom: "1.5%",
    width: "48.5%", 
    backgroundColor: "white",
  },
  textNoteSupport: {
    fontSize: 18,  
    color: "black",
    marginLeft: "2%",
    paddingLeft: "1.5%",
    marginBottom: "1.5%",
    marginRight: "2%",
    //width: "45.5%", //48.5%
    backgroundColor: "white",
  },
  textBoxQtyMesure:{
    fontSize: 17,  
    color: "black",
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "55%",
    backgroundColor: "white",
    },
  textBoxQty:{
    fontSize: 17,  
    color: "black",
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "60%",
    backgroundColor: "white",
    },
  textBoxMesure:{
    fontSize: 17,  
    color: "black",
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "45%",
    backgroundColor: "white",
    },
  textBoxPrice:{
    fontSize: 17,  
    color: "black",
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "45%",
    backgroundColor: "white",
    },
   textBoxSub:{
    fontSize: 17,  
    color: "black",
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "73%",
    backgroundColor: "white",
    },
  buttonsTop: {
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  card: {
    //borderRadius: 15,
    backgroundColor: colors.light, 
    marginTop: "2%",
    overflow: "hidden",
    borderRadius: 15,
  },
  cardApoyo: {
    borderRadius: 15,
    backgroundColor: colors.fuente, 
    marginBottom: "2%",
    marginTop: "2%",
    overflow: "hidden",
  },
  viewContent6PhotoYText: {
    borderRadius: 15,
    backgroundColor: colors.light,
    //marginBottom: 15,
    //overflow: "hidden",
    flexDirection: "row",
  },
  viewApoyo: {
    borderRadius: 15,
    backgroundColor: colors.fuente,
    flexDirection: "row",
  },
  viewContent6Image: {
    //backgroundColor: "red", //colors.chakra2ama,
    marginLeft: "1%",
    backgroundColor: '#00000000', // Le puse este color esperando se vuelva transparente '#00000000',
    width: "70%",
    height: 120,
    alignContent: "space-between",
  },
  viewImageUser: {
    //backgroundColor: "red", //colors.chakra2ama,
    justifyContent: 'space-evenly', // Esto hace que las imágenes se centren verticalmente no importando que tanto crezca el texto.
    marginLeft: "1%",
    backgroundColor: colors.fuente, // Le puse este color esperando se vuelva transparente '#00000000',
    width: "18%",
  },
  viewContent6TitleYSeedDescription: {
    backgroundColor: colors.chakra2ama,
    width: "130%",
    marginLeft: "-38%",
  },
  viewContent6TitleYSeedDescriptionApoyo: {
    backgroundColor: colors.fuente,
    width: "76%",
    marginLeft: "1%",
  },
  Title6:{
    fontSize: 20,  
    color: "black",
    marginLeft: "2%",
    marginTop: "1%", 
    paddingLeft: "1%",
    width: "50%",
    backgroundColor: "white",
    },
    seedDescription6: {
      marginBottom: 7,
      marginTop: "1.5%",
      //width: "350%",
      textAlign: "justify",
    },
    buttonEdit: {
      margin: "1%",
      backgroundColor: colors.primary,
      borderRadius: 15,
      justifyContent: "center",
      alignItems: "center",
      padding: 4,
    },
    buttonVerApoyos: {
      marginLeft: "5%",
      backgroundColor: colors.primary,
      borderRadius: 15,
      justifyContent: "center",
      alignItems: "center",
      padding: 4,
      width: "40%",
      marginRight: "5%",
    },
    textEdit: {
      color: colors.white,
      fontSize: 18,
    },
  detailsContainer: {
    padding: 20,
  },
  image: {
    marginTop: "2%",
    width: 120,  // Para que funcione resizeMode= "stretch" en las propiedades de ImageCache arriba tanto width como heigth deben estar en pixeles, ninguno en porcentajes.
    height: 120,  
    backgroundColor: colors.chakra8tur,
  },
  imageUser: {
    width: 74,
    height: 74,
    borderRadius: 37,
    marginTop: "-2%",
    marginLeft: "1%"
},
  likeAndCommentContainer: {
     flexDirection: "row",
     width: "100%",
     height: 30,
  },
  likes: {
    marginLeft: "50%",
 },
 commentsNum:{
  marginLeft: "70%",
 },
  subTitle: {
    color: colors.dark,
    fontWeight: "bold",
  },
  title: {
    marginBottom: 7,
  },
  
});

export default CardRequirements;



